<app-header></app-header>
<ng-container *ngIf="isLoading">
    <fn-menu-sidebar ></fn-menu-sidebar>
    <section class="content-wrapper main-content" id="main-content">
        <div class="hw-box-content">
            <router-outlet></router-outlet>
        </div>
    </section>
</ng-container>
